// This file is deprecated. Credit check requests are now handled by the CreditCheckService
// which uses Supabase real-time subscriptions to watch for opt_in changes.
// See src/services/CreditCheckService.ts for the new implementation.

// Keeping this file for reference but removing the trigger-based approach
// to avoid duplicate credit check requests.

import { supabase } from '../supabase';
import { api } from './api';

// All functionality has been moved to CreditCheckService
// This file is kept for reference only
// To prevent any accidental usage, all functions are disabled

export function setupOptInSubscription() {
  console.log('SOFTPULL: This function is deprecated. Use CreditCheckService instead.');
  return null;
}

export async function directWebhookTest(customerId: number, rooftopId: string) {
  console.log('SOFTPULL: This function is deprecated. Use CreditCheckService instead.');
  return { success: false, error: 'Function deprecated' };
}

export async function testOptIn(customerId: number, rooftopId: string) {
  console.log('SOFTPULL: This function is deprecated. Use CreditCheckService instead.');
  return { success: false, error: 'Function deprecated' };
} 